import {useEffect, useState} from "react";
import {toast} from "react-toastify";
import Header from "../blocks/header";
import TextField from "@mui/material/TextField";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {connect} from "react-redux";
import {editSaveReport, getReport, messageReset, reportSave} from "../store/reports";
import {getAllVerifyResponse} from "../store/logIn";
import Dashboard from "../blocks/dashboard";
import Toolbar from "@mui/material/Toolbar";
import * as React from "react";
import Copyright from "../blocks/copyright";
import {useTranslation} from "react-i18next";
import {DatePicker} from "@mui/x-date-pickers";
import {useNavigate, useParams} from "react-router-dom";
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import CancelModal from "../blocks/cancelModal";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";


function EditReport(props) {
    const is_main = JSON.parse(localStorage.getItem('is_main'));


    const can_review = is_main
    const my_user_id = JSON.parse(localStorage.getItem('user_id') || '0');
    // report yuklanganidan keyin user ID ni olamiz
    const report_user_id = props.report_data?.user?.id || 0
    const navigate = useNavigate()
    const {t, i18n} = useTranslation()
    const [report, setReport] = useState('');
    const [hasError, setHasError] = useState(false);
    const [hasError1, setHasError1] = useState(false);
    const [year, setYear] = useState(new Date("2022-01-01"));
    const [period, setPeriod] = useState('');
    const [year_plan, setYearPlan] = useState('');
    const [year_plan_currently, setYearPlanCurrently] = useState('');
    const [year_plan_currently_percent, setYearPlanCurrentlyPercent] = useState('');
    const [year_plan_price, setYearPlanPrice] = useState('');
    const [year_plan_price_percent, setYearPlanPricePercent] = useState('');
    const [new_eployees, setNewEployees] = useState('');
    const [new_eployees_invalid, setNewEployeesInvalid] = useState('');
    const [all_new_eployees, setAllNewEployees] = useState('');
    const [all_new_eployees_invalid, setAllNewEployeesInvalid] = useState('');
    const [new_eployees_price, setNewEployeesPrice] = useState('');
    const [new_eployees_price_invalid, setNewEployeesPriceInvalid] = useState('');
    const [salary_all, setSalaryAll] = useState('');
    const [salary_all_invalid, setSalaryAllInvalid] = useState('');
    const [salary_one, setSalaryOne] = useState('');
    const [salary_one_invalid, setSalaryOneInvalid] = useState('');
    const [products, setProducts] = useState([{title: '', measure: '', amount: '', product_number: ''}]);
    const [responsible_person, setResponsiblePerson] = useState('');
    const [isSend, setIsSend] = useState(false);
    const [isAmounts, setIsAmounts] = useState(false);
    const [is_status, setIsStatus] = useState(2);
    const [comment, setComment] = useState('');
    const [open, setOpen] = useState(false);
    const [data, setData] = useState(false);
    const params = useParams()
    const toBack = () => {
        navigate(-1);
    }


    useEffect(() => {
        props.getReport(params.id)
    }, [])

    useEffect(() => {
        if (props.report_single.id === parseInt(params.id)) {
            setReport(props.report_single.type)
            setYear(new Date(props.report_single.year))
            setPeriod(props.report_single.month)
            setYearPlan(parseInt(props.report_single.year_plan))
            setYearPlanCurrently(props.report_single.year_plan_currently)
            setYearPlanCurrentlyPercent(props.report_single.year_plan_currently_percent)
            setYearPlanPrice(props.report_single.year_plan_price)
            setYearPlanPricePercent(props.report_single.year_plan_price_percent)
            setNewEployees(props.report_single.new_employees_all)
            setNewEployeesInvalid(props.report_single.new_employees_invalid)
            setAllNewEployees(props.report_single.employees_all)
            setAllNewEployeesInvalid(props.report_single.employees_invalid)
            setNewEployeesPrice(props.report_single.all_members)
            setNewEployeesPriceInvalid(props.report_single.all_members_invalid)
            setSalaryAll(props.report_single.price_emloyees_all)
            setSalaryAllInvalid(props.report_single.price_emloyees_all_invalid)
            setSalaryOne(props.report_single.average_salary)
            setSalaryOneInvalid(props.report_single.average_salary_invalid)
            setResponsiblePerson(props.report_single.responsible_person || '')
            setIsSend(props.report_single.is_send)
            setProducts(props.report_single.products && props.report_single.products.length > 0 ? props.report_single.products : [{
                title: '',
                measure: '',
                amount: '',
                product_number: ''
            }])
        }
    }, [props.report_single])


    useEffect(()=>{
        if(year_plan_currently && year_plan){
            let myInt = Number(year_plan_currently) / Number(year_plan) * 100
            setYearPlanCurrentlyPercent(Math.round(myInt))
        }
    }, [year_plan, year_plan_currently])

    function CancelReport(){
        setIsStatus(3)
        setOpen(true)
    }

    function AddProduct() {
        let data = {title: '', measure: '', amount: '', product_number: ''}
        return setProducts([...products, data])
    }

    function RemoveProduct() {
        var my_products = products
        my_products.pop()
        return setProducts([...my_products])
    }

    function changeTitle(itemIndex, val) {
        setProducts(prevState => prevState.map((item, index) => index === itemIndex ?
            {...item, title: val}
            : item))
    }

    function changeMeasure(itemIndex, val) {
        setProducts(prevState => prevState.map((item, index) => index === itemIndex ?
            {...item, measure: val}
            : item))
    }

    function changeAmount(itemIndex, val) {
        setProducts(prevState => prevState.map((item, index) => index === itemIndex ?
            {...item, amount: val}
            : item))
    }

    function changeProductNumber(itemIndex, val) {
        setProducts(prevState => prevState.map((item, index) => index === itemIndex ?
            {...item, product_number: val}
            : item))
    }

    function saveFormData(e) {
        e.preventDefault()
        let sum_products = 0
        for (let i = 0; i < products.length; i++) {
            sum_products += Number(products[i].amount)
        }
        if (Number(year_plan_currently) !== sum_products){
            setIsAmounts(true)
        } else{
            setIsAmounts(false)
        }
        if (!report) {
            setHasError(true)
        } else {
            setHasError(false)
        }
        if (!period) {
            setHasError1(true)
        } else {
            setHasError1(false)
        }
        if (is_status === 3){
            setOpen(true)
        }
        if (Number(year_plan_currently) === sum_products){
            const data = {
                "id": params.id,
                "type": report,
                "responsible_person": responsible_person,
                "year": year ? (year.$y || new Date(year).getFullYear()).toString() : new Date().getFullYear().toString(),
                "month": period,
                "year_plan": year_plan,
                "year_plan_currently": year_plan_currently,
                "year_plan_currently_percent": year_plan_currently_percent,
                "year_plan_price": year_plan_price,
                "year_plan_price_percent": year_plan_price_percent,
                "new_employees_all": new_eployees,
                "new_employees_invalid": new_eployees_invalid,
                "employees_all": all_new_eployees,
                "employees_invalid": all_new_eployees_invalid,
                "all_members": new_eployees_price,
                "all_members_invalid": new_eployees_price_invalid,
                "price_emloyees_all": salary_all,
                "price_emloyees_all_invalid": salary_all_invalid,
                "average_salary": salary_one,
                "average_salary_invalid": salary_one_invalid,
                "products": products,
                "is_send": isSend,
            }
            if (isSend && !is_main && !can_review) {
                // Yuborish — status 2 ga o'tadi
                data['status'] = 2
            } else if (!isSend && !is_main && !can_review) {
                // Saqlash — yuborilmagan statusda qoladi (status=1)
                data['status'] = 1
            } else {
                data['status'] = is_status
            }
            if (is_main && !comment && is_status===3){
                setData(data)
            }else{
                props.editSaveReport(data)
            }
        }
    }

    useEffect(()=>{
        if(year_plan_currently && year_plan){
            let myInt = Number(year_plan_currently) / Number(year_plan) * 100
            setYearPlanCurrentlyPercent(Math.round(myInt))
        }else{
            setYearPlanCurrentlyPercent('')
        }
    }, [year_plan, year_plan_currently])

    // Davrga mos oylar soni: 1-kvartal=3, yarim yillik=6, 9 oylik=9, yillik=12
    function periodMonths(p) {
        const map = {1: 3, 2: 6, 3: 9, 4: 12}
        return map[Number(p)] || 12
    }

    useEffect(()=>{
        if(new_eployees_price && salary_all && period){
            let myInt = (Number(salary_all) / Number(new_eployees_price)) / periodMonths(period)
            setSalaryOne(myInt.toFixed(3))
        }else{
            setSalaryOne('')
        }
    }, [salary_all, new_eployees_price, period])

    useEffect(()=>{
        if(new_eployees_price_invalid && salary_all_invalid && period){
            let myInt = (Number(salary_all_invalid) / Number(new_eployees_price_invalid)) / periodMonths(period)
            setSalaryOneInvalid(myInt.toFixed(3))
        }else{
            setSalaryOneInvalid('')
        }
    }, [salary_all_invalid, new_eployees_price_invalid, period])

    useEffect(()=>{
        if(year_plan_price){
            let myInt = (Number(year_plan_price) / 100) * 2
            setYearPlanPricePercent(myInt.toFixed(1))
        }else{
            setYearPlanPricePercent('')
        }
    }, [year_plan_price])

    useEffect(() => {
        if (props.message === true) {
            setReport('')
            setYear(new Date("2022-01-01"))
            setPeriod('')
            setYearPlan('')
            setYearPlanCurrently('')
            setYearPlanCurrentlyPercent('')
            setYearPlanPrice('')
            setYearPlanPricePercent('')
            setNewEployees('')
            setNewEployeesInvalid('')
            setAllNewEployees('')
            setAllNewEployeesInvalid('')
            setNewEployeesPrice('')
            setNewEployeesPriceInvalid('')
            setSalaryAll('')
            setSalaryAllInvalid('')
            setSalaryOne('')
            setSalaryOneInvalid('')
            setProducts([{title: '', measure: '', amount: '', product_number: ''}])
            navigate('/reports/')
        } else if (props.message === 'error') {
            toast.error(t('save_error'), {theme: 'colored'})
            props.messageReset()
        }
    }, [props.message])

    return <div>
        <div className={'page'}>
            <Header/>
            <Dashboard/>
            <Box
                component="main"
                sx={{
                    flexGrow: 1,
                    height: '100vh',
                    overflow: 'auto',
                }}>
                <Toolbar/>
                <div className={'main'}>
                    <Button variant="outlined" startIcon={<ChevronLeftIcon />} onClick={toBack}>
                        {t('back')}
                    </Button>
                    <h2 className={'page-title text-center'}>{t('report')}</h2>
                    {props.report_single && props.report_single.user?.user_name && (
                        <div style={{textAlign:'center', fontSize:'16px', fontWeight:700, color:'#1F4E79', marginBottom:'12px'}}>
                            {props.report_single.user.user_name}
                        </div>
                    )}
                    {open ? <CancelModal editSaveReport={props.editSaveReport} data={data}  open={open} setOpen={setOpen} setComment={setComment}/> : ''}
                    {props.report_single ? <form className={'add-form add-report'} onSubmit={saveFormData}>
                        <div className={'mt-4 d-block'}>
                            <h5 className={'d-block text-uppercase'}>1. {t('report_about')}</h5>
                        </div>
                        <div>
                            <p><span>{t('type')}:</span>
                                <Box sx={{minWidth: 200}}>
                                    <FormControl fullWidth>
                                        <InputLabel error={hasError} required disabled={is_main}
                                                    id="demo-simple-select-label">{t('type')}</InputLabel>
                                        <Select
                                            error={hasError}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={report}
                                            label={t('type')}
                                            disabled={is_main}
                                            onChange={(e) => {
                                                setReport(e.target.value)
                                            }}
                                        >
                                            <MenuItem value={1}>{t('type_report')}</MenuItem>
                                            <MenuItem value={2}>{t('type_reply_report')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box></p>
                            <p><span>{t('responsible_person')}:</span>
                                <TextField
                                    label={t('responsible_person')}
                                    value={responsible_person}
                                    onChange={(e) => setResponsiblePerson(e.target.value)}
                                    type="text"
                                    variant="outlined"
                                    disabled={can_review}
                                />
                            </p>
                            <p><span>{t('report_year')}:</span>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DatePicker
                                        minDate={new Date("2022-01-01")}
                                        views={['year']}
                                        label={t('report_year')}
                                        value={year}
                                        onChange={(newValue) => {
                                            setYear(newValue);
                                        }}
                                        required disabled={is_main}
                                        renderInput={(params) => <TextField required disabled={is_main}  {...params}
                                                                            helperText={null}/>}
                                    />
                                </LocalizationProvider>
                            </p>
                            <p><span>{t('report_month')}:</span>
                                <Box sx={{minWidth: 200}}>
                                    <FormControl fullWidth>
                                        <InputLabel error={hasError1} required disabled={is_main}
                                                    id="demo-simple-select-label">{t('report_month')}</InputLabel>
                                        <Select
                                            error={hasError1}
                                            labelId="demo-simple-select-label"
                                            id="demo-simple-select"
                                            value={period}
                                            disabled={is_main}
                                            label={t('report_month')}
                                            onChange={(e) => {
                                                setPeriod(e.target.value)
                                            }}
                                        >
                                            <MenuItem value={1}>{t('quarter')}</MenuItem>
                                            <MenuItem value={2}>{t('semi_annual')}</MenuItem>
                                            <MenuItem value={3}>{t('nine_month')}</MenuItem>
                                            <MenuItem value={4}>{t('yearly')}</MenuItem>
                                        </Select>
                                    </FormControl>
                                </Box></p>
                        </div>
                        <div className={'mt-4 d-block'}>
                            <h5 className={'d-block text-uppercase'}>2. {t('report')}</h5>
                        </div>
                        <table className="add-report table table-bordered">
                            <tbody>
                            <tr>
                                <th>{t('year_plan')} <small style={{color:'#888',fontSize:'0.78em'}}>(минг сўм)</small></th>
                                <td>
                                    <TextField
                                        label={t('year_plan')}
                                        value={year_plan}
                                        onChange={(e) => setYearPlan(e.target.value)}
                                        required disabled={is_main}
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('year_plan_currently')} <small style={{color:'#888',fontSize:'0.78em'}}>(минг сўм)</small></th>
                                <td>
                                    <TextField
                                        label={t('year_plan_currently')}
                                        value={year_plan_currently}
                                        error={isAmounts}
                                        onChange={(e) => setYearPlanCurrently(e.target.value)}
                                        name="numberformat" required disabled={is_main}
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('year_plan_currently_percent')}</th>
                                <td>
                                    <TextField
                                        label={t('year_plan_currently_percent')}
                                        value={year_plan_currently_percent}
                                        name="numberformat" required disabled
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('year_plan_price')} <small style={{color:'#888',fontSize:'0.8em'}}>(ming so'm)</small></th>
                                <td>
                                    <TextField
                                        label={t('year_plan_price')}
                                        value={year_plan_price}
                                        onChange={(e) => setYearPlanPrice(e.target.value)}
                                        name="numberformat" required disabled={is_main}
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('year_plan_price_percent')} <small style={{color:'#888',fontSize:'0.8em'}}>(ming so'm)</small></th>
                                <td>
                                    <TextField
                                        label={t('year_plan_price_percent')}
                                        value={year_plan_price_percent}
                                        disabled
                                        // onChange={(e) => setYearPlanPricePercent(e.target.value)}
                                        name="numberformat"
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('new_eployees')}</th>
                                <td><TextField
                                    label={t('new_eployees')}
                                    value={new_eployees}
                                    onChange={(e) => setNewEployees(e.target.value)}
                                    name="numberformat" required disabled={is_main}
                                    id="formatted-numberformat-input"
                                    type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                    variant="outlined"
                                /></td>
                            </tr>
                            <tr>
                                <th>{t('new_eployees_invalid')}</th>
                                <td>
                                    <TextField
                                        label={t('new_eployees_invalid')}
                                        value={new_eployees_invalid}
                                        onChange={(e) => setNewEployeesInvalid(e.target.value)}
                                        name="numberformat" required disabled={is_main}
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('all_new_eployees')}</th>
                                <td>
                                    <TextField
                                        label={t('all_new_eployees')}
                                        value={all_new_eployees}
                                        onChange={(e) => setAllNewEployees(e.target.value)}
                                        name="numberformat" required disabled={is_main}
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('all_new_eployees_invalid')}</th>
                                <td>
                                    <TextField
                                        label={t('all_new_eployees_invalid')}
                                        value={all_new_eployees_invalid}
                                        onChange={(e) => setAllNewEployeesInvalid(e.target.value)}
                                        name="numberformat" required disabled={is_main}
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('new_eployees_price')}</th>
                                <td>
                                    <TextField
                                        label={t('new_eployees_price')}
                                        value={new_eployees_price}
                                        onChange={(e) => setNewEployeesPrice(e.target.value)}
                                        name="numberformat" required disabled={is_main}
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>
                                    {t('new_eployees_price_invalid')}
                                </th>
                                <td><TextField
                                    label={t('new_eployees_price_invalid')}
                                    value={new_eployees_price_invalid}
                                    onChange={(e) => setNewEployeesPriceInvalid(e.target.value)}
                                    name="numberformat" required disabled={is_main}
                                    id="formatted-numberformat-input"
                                    type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                    variant="outlined"
                                /></td>
                            </tr>
                            <tr>
                                <th>{t('salary_all')}</th>
                                <td>
                                    <TextField
                                        label={t('salary_all')}
                                        value={salary_all}
                                        onChange={(e) => setSalaryAll(e.target.value)}
                                        name="numberformat" required disabled={is_main}
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('salary_all_invalid')}</th>
                                <td>
                                    <TextField
                                        label={t('salary_all_invalid')}
                                        value={salary_all_invalid}
                                        onChange={(e) => setSalaryAllInvalid(e.target.value)}
                                        name="numberformat" required disabled={is_main}
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('salary_one')}</th>
                                <td>
                                    <TextField
                                        label={t('salary_one')}
                                        value={salary_one}
                                        disabled
                                        name="numberformat" required
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th>{t('salary_one_invalid')}</th>
                                <td>
                                    <TextField
                                        label={t('salary_one_invalid')}
                                        value={salary_one_invalid}
                                        disabled
                                        name="numberformat" required
                                        id="formatted-numberformat-input"
                                        type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                        variant="outlined"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <th colSpan={2} className={'text-center products'}>{t('products')}</th>
                            </tr>
                            </tbody>
                            {products.map((item, index) =>
                                <tbody key={index}>
                                <tr>
                                    <th>{t('product_title')}</th>
                                    <td><TextField
                                        label={t('product_title')}
                                        value={item.title}
                                        onChange={(e) => changeTitle(index, e.target.value)}
                                        name="product_title"
                                        variant="outlined"
                                        required disabled={is_main}
                                    /></td>
                                </tr>
                                <tr>
                                    <th>{t('product_type')}</th>
                                    <td>
                                        <TextField
                                            label={t('product_type')}
                                            value={item.measure}
                                            onChange={(e) => changeMeasure(index, e.target.value)}
                                            name="product_type"
                                            variant="outlined"
                                            required disabled={is_main}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('product_number')}</th>
                                    <td>
                                        <TextField
                                            label={t('product_number')}
                                            value={item.product_number}
                                            onChange={(e) => changeProductNumber(index, e.target.value)}
                                            variant="outlined"
                                            name="product_number"
                                            id="formatted-numberformat-input"
                                            type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            required disabled={is_main}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <th>{t('product_price')}</th>
                                    <td>
                                        <TextField
                                            label={t('product_price')}
                                            value={item.amount}
                                            error={isAmounts}
                                            onChange={(e) => changeAmount(index, e.target.value)}
                                            name="product_price"
                                            id="formatted-numberformat-input"
                                            type={"number"} onKeyDown={(evt) => evt.key === 'e' && evt.preventDefault()}
                                            variant="outlined"
                                            required disabled={is_main}
                                            helperText={isAmounts ? t('not_amount') : t('amounts')}
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                        <hr/>
                                    </td>
                                </tr>
                                </tbody>
                            )}
                            {!is_main ? <tbody className={'add-product-btn'}>
                            <tr>
                                <td colSpan={2}>
                                    <Button onClick={AddProduct} style={{width: '25%'}} variant="contained" fullWidth
                                            color={'primary'}
                                            endIcon={<AddIcon/>} title={t('add_product')}/>
                                    {products.length > 1 ?
                                        <Button onClick={RemoveProduct} style={{width: '25%'}} variant="contained"
                                                fullWidth color={'error'}
                                                endIcon={<RemoveIcon/>} title={t('delete_product')}/> : ''}

                                </td>
                            </tr>
                            </tbody> : <tr/>}
                        </table>
                        <div>
                        </div>
                        <div>
                        </div>
                        {!can_review ?
                            <div className="button-group">
                                <Button type={'submit'} style={{width: '25%'}} variant="contained"
                                        fullWidth color={'info'} onClick={() => setIsSend(false)}>
                                    {t('save')}
                                </Button>
                                <Button type={'submit'} style={{marginLeft: '20px', width: '25%'}} variant="contained"
                                        fullWidth color={'success'} onClick={() => setIsSend(true)}>
                                    {t('send')}
                                </Button>
                            </div> :
                            <div className="button-group">
                                <Button type={'submit'} style={{width: '25%'}} variant="contained"
                                        fullWidth color={'error'} onClick={CancelReport}>
                                    {t('to_canceled')}
                                </Button>
                                <Button type={'submit'} style={{marginLeft: '20px', width: '25%'}} variant="contained"
                                        fullWidth color={'success'} onClick={() => setIsStatus(4)}>
                                    {t('to_accepted')}
                                </Button>
                            </div>
                        }
                    </form> : ''}
                </div>
                <Copyright/>
            </Box>
        </div>
    </div>
}

export default connect(props => props.report, {
    getReport,
    editSaveReport,
    getAllVerifyResponse,
    messageReset
})(EditReport)